import { Table, TableCell, TableRow, TableHead } from "@mui/material";
import { useTranslation } from "react-i18next";

import { S } from "./green-financing-hero.styles";

const bankData = [
    {
        name: "Nordea",
        link: "https://www.nordea.dk/",
        greenLoan: {
            interestRate: "3.25%",
            borrowPercentage: "85%",
            monthlyPayment: "750,000 kr.",
        },
        standardLoan: {
            interestRate: "3.50%",
            borrowPercentage: "75%",
            monthlyPayment: "880,000 kr.",
        },
    },
    {
        name: "Nykredit",
        link: "https://www.nykredit.dk/",
        greenLoan: {
            interestRate: "2.35%",
            borrowPercentage: "75%",
            monthlyPayment: "500,000 kr.",
        },
        standardLoan: {
            interestRate: "2.50%",
            borrowPercentage: "65%",
            monthlyPayment: "785,000 kr.",
        },
    },
];

export const GreenFinancingHero = () => {
    const { t } = useTranslation();

    return (
        <S.Hero>
            <S.Header>
                <S.Title>
                    {t("legacyNext.greenFinancing", "Green Financing")}
                </S.Title>
                <S.Description>
                    {t(
                        "legacyNext.greenFinancingDescription",
                        "The property qualifies for a green loan with"
                    )}
                </S.Description>
            </S.Header>
            <S.BankList>
                {bankData.map((bank) => (
                    <S.BankCard key={bank.name}>
                        <S.BankTitle variant="h2">{bank.name}</S.BankTitle>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell />
                                    <S.TableHeader>
                                        {t(
                                            "legacyNext.greenLoan",
                                            "Green Loan"
                                        )}
                                    </S.TableHeader>
                                    <S.TableHeader>
                                        {t(
                                            "legacyNext.standardLoan",
                                            "Standard Loan"
                                        )}
                                    </S.TableHeader>
                                </TableRow>
                            </TableHead>
                            <S.TableBody>
                                <TableRow>
                                    <S.TableLabel>
                                        {t(
                                            "legacyNext.interestRate",
                                            "Interest Rate"
                                        )}
                                    </S.TableLabel>
                                    <S.TableCell>
                                        {bank.greenLoan.interestRate}
                                    </S.TableCell>
                                    <S.TableCell>
                                        {bank.standardLoan.interestRate}
                                    </S.TableCell>
                                </TableRow>
                                <TableRow>
                                    <S.TableLabel>
                                        {t(
                                            "legacyNext.howMuchBorrow",
                                            "How much you can borrow?"
                                        )}
                                    </S.TableLabel>
                                    <S.TableCell>
                                        {t("legacyNext.upTo", "Up to")}
                                        {bank.greenLoan.borrowPercentage}
                                        {t(
                                            "legacyNext.ofTheValue",
                                            "of the value"
                                        )}
                                    </S.TableCell>
                                    <S.TableCell>
                                        {t("legacyNext.upTo", "Up to")}
                                        {bank.standardLoan.borrowPercentage}
                                    </S.TableCell>
                                </TableRow>
                                <TableRow>
                                    <S.TableLabel>
                                        {t(
                                            "legacyNext.monthlyPayment",
                                            "Monthly Payment"
                                        )}
                                    </S.TableLabel>
                                    <S.TableCell>
                                        {bank.greenLoan.monthlyPayment}
                                    </S.TableCell>
                                    <S.TableCell>
                                        {bank.standardLoan.monthlyPayment}
                                    </S.TableCell>
                                </TableRow>
                            </S.TableBody>
                        </Table>
                        <S.Footer>
                            <S.Link href={bank.link} target="_blank">
                                {t(
                                    "legacyNext.applyForLoan",
                                    "Apply for a loan"
                                )}
                                <S.ArrowIcon />
                            </S.Link>
                        </S.Footer>
                    </S.BankCard>
                ))}
            </S.BankList>
        </S.Hero>
    );
};
